export const ClvrPrscDefaultAutosizeMargin = 45
